import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { SourceData, getSourceQuery, ActionButtons } from "./details-page";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { deleteSourceMutation } from "./table";

const SourceDetailsPage = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const { currentCustomerId } = useCurrentCustomerContext();

  const query = useMemo(() => getSourceQuery(id), [id]);
  const { data, loading, error } = useQuery(query);
  const source = data.source;
  const sourceName = source ? source.description : "";

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={source}>
        <PageHeaderBar
          showBackButton
          title="app.page.source.details.title"
          titleParams={{ sourceName: source ? source.description : null }}
          buttons={
            <ActionButtons
              id={id}
              customerId={currentCustomerId}
              name={sourceName}
              mutation={deleteSourceMutation}
              history={history}
            />
          }
        />
        <PageSection hideBackground>
          <SourceData source={source} />
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default SourceDetailsPage;
